export const UPDATE = 'bodyWeight/update';
export const ADD_WEIGHT_MEASURE = 'bodyWeight/addWeightMeasure';
